import React from 'react';
import styled, { css } from '../../styled';
import Breadcrumb from '../breadcrumb';
import * as Icons from '../icons';
import { Dropdown } from '../dropdown';
const Container = styled.div `
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  box-shadow: 0 0.0625rem 0.1875rem 0
      ${({ theme }) => theme.colors.SHADOW_LIGHT},
    0 0 0.0625rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT};
  padding-right: 1.5rem;

  ::after {
    content: ' ';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 1.5rem;
    background-color: ${({ theme }) => theme.colors.SNOW_100};
  }
`;
const BackLink = styled.a `
  padding: 1.3125rem 1rem;
  margin-right: 0.5rem;
  line-height: 0;
  background-color: ${({ theme }) => theme.colors.INK_900};
  &:hover {
    background-color: ${({ theme }) => theme.colors.INK_800};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.INK_700};
  }
`;
const Wrapper = styled.div `
  margin: 0 0.25rem;
  display: inline-flex;
  align-items: center;
  padding: 0 0.25rem;
`;
const BreadcrumbWrapper = styled(Wrapper) `
  ${({ breadcrumbExtraWidth }) => breadcrumbExtraWidth &&
    css `
      width: calc(100% - ${breadcrumbExtraWidth});
    `}

  > div:first-child {
    white-space: nowrap;
    overflow: hidden;
    > span:last-child {
      font-size: 1.25rem;
    }
    > svg {
      padding: 0.25rem;
    }
  }
`;
const BreadcrumbExtraWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  padding-left: 0.25rem;
  overflow: inherit;
`;
const RightItemWrapper = styled.div `
  padding: ${({ breadcrumbExtraWidth }) => breadcrumbExtraWidth ? '0 0.25rem' : '0 0.25rem 0 0.75rem'};
  display: inline-flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1.5rem;
`;
const FullPageHeader = ({ backUrl, breadcrumbItems, breadcrumbExtraWidth, renderBreadcrumbExtraItem, languageDropdown: { placeHolder, options, isOpen, value, onClick, onClose, onChange, }, renderRightItem, e2eBackButtonId, e2eLangDropdownId, }) => {
    return (React.createElement(Container, null,
        React.createElement(BackLink, { "data-e2e-id": e2eBackButtonId, href: backUrl },
            React.createElement(Icons.Outline.Arrow, { color: "INK_400", size: "LARGE", position: "LEFT" })),
        React.createElement(Wrapper, null,
            React.createElement(Dropdown, { width: "6.5rem", options: options, isOpen: isOpen, value: value, placeHolder: placeHolder, onClick: onClick, onClose: onClose, onChange: onChange, menuAlign: "left", e2eId: e2eLangDropdownId })),
        React.createElement(BreadcrumbWrapper, { breadcrumbExtraWidth: breadcrumbExtraWidth },
            React.createElement(Breadcrumb, { items: breadcrumbItems }),
            renderBreadcrumbExtraItem && (React.createElement(BreadcrumbExtraWrapper, null, renderBreadcrumbExtraItem()))),
        renderRightItem && (React.createElement(RightItemWrapper, null, renderRightItem()))));
};
export default FullPageHeader;
//# sourceMappingURL=index.js.map